module.exports = __webpack_public_path__ + "img/bighaibao3.fe6819bc.png";